import { render, staticRenderFns } from "./organization-physical-archive-form.vue?vue&type=template&id=4160e386"
import script from "./organization-physical-archive-form.vue?vue&type=script&lang=js"
export * from "./organization-physical-archive-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports